import {closeModalHelper, openModalHelper, toggleElement} from '../../js/helpers/modals'
import {
  validateMail,
  validateMails,
  validatePassword,
} from '../../js/helpers/validations'

export default () => {
  let $ = jQuery

  $('.view-password').on('click', function () {
    let $passwordInput = $(this).parent().find('input')
    if ($passwordInput.attr('type') === 'password') {
      $passwordInput.attr('type', 'text')
    } else {
      $passwordInput.attr('type', 'password')
    }
  })

  const steps = Array.from(document.querySelectorAll('.form-profile__step'))
  let formCategory = $('.form-profile-wrapper').data('category')

  //const mainModal = document.querySelector('.form-profile')
  //const modalWrap = document.querySelector('.form-profile-wrap')
  const modalStatusWrap = document.querySelector('.form-status-wrap')
  const mainModalStatus = document.querySelector('.form-status')

  const thankYouModal = document.querySelector('.form-profile-thank')
  const errorModal = document.querySelector('.form-profile-error')

  const submitStatusElems = document.querySelectorAll('.submit-modal-form')

  const statusChooseBtn = document.querySelectorAll('.status-choose-btn')

  const modalClose = Array.from(document.querySelectorAll('.form-profile__close'))
  const modalHandlers = Array.from(document.querySelectorAll('.form-profile-handler'))

  const pageprofile = Array.from(document.querySelectorAll('.form-page-profile'))

  const loader = document.querySelector('.form-profile-loader')

  let formData = []
  let stepId = 1
  let stepCurrent = null
  let lastStep = 3

  const openStep = id => {
    steps.forEach(step => step.classList.remove('active'))
    stepCurrent = document.querySelector(`.form-profile__step[data-step="${id}"]`)
    stepCurrent.classList.add('active')
  }

  /*modalHandlers.forEach((modalHandler) => {
    modalHandler.addEventListener('click', (event) => {
      event.preventDefault()
      modalWrap.classList.add('opened')
      openModalHelper()
      toggleElement(mainModal)
      openStep(1)
    })
  })*/

  modalHandlers.forEach((modalHandler) => {
    modalHandler.addEventListener('click', event => {
      event.preventDefault()
      modalStatusWrap.classList.add('opened')
      openModalHelper()
      toggleElement(mainModalStatus)
      openStep(1)
    })
  })

  /*modalClose.forEach(function (modalCloseEl) {
    modalCloseEl.addEventListener('click', () => {
      modalWrap.classList.remove('opened')
      const parent = modalCloseEl.closest('.form-profile-popup')
      toggleElement(parent)
      closeModalHelper()
      stepId = 1
      formData = []
    })
  })*/

  modalClose.forEach(function (modalCloseEl) {
    modalCloseEl.addEventListener('click', () => {
      modalStatusWrap.classList.remove('opened')
      const parent = modalCloseEl.closest('.form-status')
      toggleElement(parent)
      closeModalHelper()
      stepId = 1
    })
  })

  submitStatusElems.forEach(submitStatus => {
    submitStatus.addEventListener('click', function (event) {
      event.preventDefault()

      if (stepId !== lastStep) {
        let parent = event.target.closest('form')
        let status = ''

        if (parent.querySelector('.status-choose-btn.selected')) {
          status = parent.querySelector('.status-choose-btn.selected').textContent.trim()
        }

        let $radioCheckedValue = $('.js-radio-status:checked').val()
        localStorage.setItem('role', $radioCheckedValue)

        if (localStorage.getItem('role') === 'Seller') {
          $('.form-profile__step-text').hide()
          $('.change-step-btn').val('Create Account')
        } else {
          $('.form-profile__step-text').show()
          $('.change-step-btn').val('Next')
        }

        if (status === 'Buyer') {
          parent.classList.remove('active')
          stepId = stepId + 1
          openStep(stepId)
        } else if (status === 'Seller') {
          parent.classList.remove('active')
          stepId = 2
          stepId = stepId + 1
          openStep(stepId)
        } else {
          parent.classList.remove('active')
          stepId = stepId + 1
          openStep(stepId)
        }
      }
    })
  })

  document
    .querySelector('.modal__choose-wrap')
    .addEventListener('click', function (event) {
      if (event.target.classList.contains('status-choose-btn')) {
        const selected = this.querySelector('.selected')
        if (selected) selected.classList.remove('selected')
        event.target.classList.add('selected')
      }

      if (event.target.classList.contains('js-radio-status')) {
        const radio = this.querySelector('.js-radio-status')
        radio.checked
      }
    })

  // collecting data from steps
  // steps.forEach((step, stepId) => {
  //   step.addEventListener('submit', function (event) {
  //     event.preventDefault()

  //     $('form[data-step="1"]').validate({
  //       rules: {
  //         first_name: {
  //           required: true,
  //           maxlength: 50,
  //           minlength: 1,
  //         },
  //         last_name: {
  //           required: true,
  //           maxlength: 50,
  //           minlength: 1,
  //         },
  //         phone: {
  //           required: true,
  //           number: true,
  //         },
  //         email: {
  //           required: true,
  //           email: true,
  //           maxlength: 50,
  //           minlength: 1,
  //         },
  //       },
  //       messages: {
  //         first_name: {
  //           required: 'Please specify your fisrt name',
  //         },
  //         last_name: {
  //           required: 'Please specify your last name',
  //         },
  //         phone: {
  //           required: 'Please provide a phone number',
  //           number: 'Please enter a valid number (without +)',
  //         },
  //         email: {
  //           required: 'Please enter your email',
  //           email: 'Please enter a valid email address',
  //         },
  //       },
  //     })

  //     if (stepId == 2 && checkForErrors(step)) return

  //     if ($('form[data-step="1"]').valid()) {
  //       const stepData = $(step).serializeArray()
  //       stepData.forEach((obj) => {
  //         obj.meaning = document
  //           .querySelector(`input[name="${obj.name}"]`)
  //           .getAttribute('data-name')
  //       })

  //       formData.push(...stepData)

  //       stepId = +step.getAttribute('data-step') + 1
  //       if (stepId < 5) openStep(stepId)
  //       if (stepId == 5) sendForm()
  //     }
  //   })
  // })

  // closing modal on clicking outside the modal
  /*modalWrap.addEventListener('click', function (event) {
    if (
      !event.target.classList.contains('.form-profile-popup') &&
      !event.target.closest('.form-profile-popup')
    ) {
      stepId = 1
      formData = []
      modalWrap.classList.remove('opened')
      mainModal.classList.remove('opened')
      if (errorModal) {
        errorModal.classList.remove('opened')
      }
      if (thankYouModal) {
        thankYouModal.classList.remove('opened')
      }
      // document.body.classList.remove('js-no-scroll')
    }

    if (event.target === modalWrap) {
      document
        .querySelectorAll('.form-profile__sub-step')
        .forEach((item, idx) => {
          item.classList.remove('active')
          if (idx === 0) {
            item.classList.add('active')
          }
        })
      closeModalHelper()
    }
  })*/

  // writing address from page profile form to modal
  // pageprofile.forEach((form) => {
  //   const btn = form.querySelector('.form-page-profile__submit')
  //   btn.addEventListener('click', function () {
  //     const address = form.querySelector('input').value
  //     const popupInput = document.querySelector(
  //       '.form-profile-popup input[name="address"]'
  //     )
  //     popupInput.value = address
  //   })
  // })

  // validation
  // function checkForErrors(form) {
  //   const inputReserve = form.querySelector('input[name="reserveAmount"]')
  //   const inputCheckbox = form.querySelector('input[name="valuationFeedback"]')
  //   if (!inputReserve || !inputCheckbox) return

  //   const formError = form.querySelector('.form-error')
  //   let errors
  //   if (inputReserve.value == '' && !inputCheckbox.checked) {
  //     errors = true
  //     formError.style.display = 'block'
  //   } else if (inputReserve.value || inputCheckbox.checked) {
  //     errors = false
  //     formError.style.display = 'none'
  //   }
  //   return errors
  // }

  const formatNumber = document.querySelectorAll('.format-number')
  if (formatNumber.length) {
    Array.from(formatNumber).forEach(function (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/[^0-9\.+]+/g, '')
      })
    })
  }

  validateMails('.form-profile input[type="email"]')
  validatePassword('.form-profile input[type="password"]')

  const signInBtn = document.querySelector('.js-sign-in')
  const signInForm = document.querySelector('.js-sign-in-form')

  signInForm.addEventListener('submit', event => {
    event.preventDefault()
    const signInFormData = $(signInForm).serializeArray()

    if (
      validateMail('.js-sign-in-form input[type="email"]') &&
      validatePassword('.form-profile input[type="password"]', true)
    ) {
      $.ajax({
        url: window.wp_data.ajax_url,
        type: 'POST',
        data: {
          action: 'logIn',
          data: signInFormData,
        },
        beforeSend: function () {
          mainModalStatus.classList.remove('opened')
          if (loader) {
            toggleElement(loader)
          }
        },
        success: function (response) {
          if (response.data.status === 'success') {
            setTimeout(() => {
              if (loader) {
                toggleElement(loader)
              }
              window.location.replace('profile')
            }, 300)
          } else {
            if (loader) {
              toggleElement(loader)
            }
            mainModalStatus.classList.add('opened')
            $(signInForm)
              .find('.form-error:first')
              .text('The email or password is incorrect')
              .css('display', 'block')
          }

          if (!response.success) {
            if (errorModal) {
              toggleElement(errorModal)
            }
          }
        },
        error: function (err) {
          mainModalStatus.classList.remove('opened')
          //toggleElement(loader)
          //toggleElement(errorModal)
          console.log(err)
        },
      })
    } else {
      return
    }
  })

  const createAccountBtn = document.querySelector('.js-create-account a')
  const registrationStep = document.querySelector('.form-profile__step[data-step="create-account"]')

  const clientTypeBtn = document.querySelectorAll('.js-client-type-btn')

  const signInStep = document.querySelector('.form-profile__step[data-step="1"]')
  const signAccountBtn = registrationStep.querySelector('.js-create-account a')

  const registrationStepTitle = registrationStep.querySelector('.form-profile__title')
  const registrationStepInfo = registrationStep.querySelector('.form-profile__info')
  const registrationStepCounter = registrationStep.querySelector('.form-profile__step-text')

  createAccountBtn.addEventListener('click', () => {
    stepCurrent.classList.remove('active')
    stepCurrent = registrationStep
    stepCurrent.classList.add('active')
  })

  signAccountBtn.addEventListener('click', () => {
    stepCurrent.classList.remove('active')
    stepCurrent = signInStep
    stepCurrent.classList.add('active')
  })

  /*clientTypeBtn.forEach((item) => {
    item.addEventListener('change', (e) => {
      if (e.target.value === 'Seller') {
        registrationStepTitle.innerHTML =
          'Add more details <wbr> to your Off Market property'
        registrationStepInfo.innerHTML = 'Register as a seller'
        registrationStepCounter.style.display = 'none'
      }
      if (e.target.value === 'Buyer') {
        registrationStepTitle.innerHTML =
          'Access NEW <wbr> off-market opportunities <wbr> on our marketplace.'
        registrationStepInfo.innerHTML = 'Register as a buyer'
        registrationStepCounter.style.display = 'block'
      }
    })
  })*/

  registrationStep.addEventListener('submit', event => {
    event.preventDefault()

    const registerFormData = $(registrationStep).serializeArray()

    const changeRegistrationStep = () => {
      if (registerFormData[0].value === 'Seller') {
        /*if (validateMail('form#create-account input[type="email"]') && validatePassword('form#create-account input[type="password"]', true)) {
          sendRegisterData()
        }*/
        sendRegisterData()
      } else if (registerFormData[0].value === 'Buyer') {
        registrationStep.querySelectorAll('.form-profile__sub-step').forEach(item => {
          if (item.dataset.subStep == 2 && item.classList.contains('active')) {
            sendRegisterData()
          } else {
            if (validateMail('form#create-account input[type="email"]')) { // && validatePassword('form#create-account input[type="password"]', true)) {
              registrationStep.removeAttribute('novalidate')
              item.classList.toggle('active')
            }
          }
        })
      }
    }

    const sendRegisterData = () => {
      $.ajax({
        url: window.wp_data.ajax_url,
        type: 'POST',
        data: {
          action: 'createAccount',
          data: registerFormData,
        },
        beforeSend: function () {
          mainModalStatus.classList.remove('opened')
          if (loader) {
            toggleElement(loader)
          }
        },
        success: function (response) {
          if (loader) {
            toggleElement(loader)
          }
          window.location.replace('profile')
        },
        error: function (err) {
          if (loader) {
            toggleElement(loader)
          }
          toggleElement(errorModal)
          console.log(err)
        },
      })
    }

    let checkForExistsEmail = true
    const emailInput = registrationStep.querySelector('input[type="email"]')
    const emailErrors = emailInput.parentNode.querySelector('.form-error')

    checkExistingEmail()
    function checkExistingEmail() {
      $.ajax({
        url: window.wp_data.ajax_url,
        type: 'POST',
        data: {
          action: 'checkForExistsEmail',
          data: [
            {
              email: emailInput.value,
            },
          ],
        },
        beforeSend: function () {
          mainModalStatus.classList.remove('opened')
          toggleElement(loader)
        },
        success: function (response) {
          checkForExistsEmail = response.data.status === 'success'
          toggleElement(loader)

          if (!checkForExistsEmail) {
            mainModalStatus.classList.add('opened')
            emailErrors.textContent = 'This email is already exists'
            emailErrors.style.display = 'block'
          } else {
            mainModalStatus.classList.add('opened')
            emailErrors.style.display = 'none'
            changeRegistrationStep()
          }
        },
        error: function (error) {
          toggleElement(loader)
          toggleElement(errorModal)
          console.log(error)
        },
      })
    }

    // COMMENT FOR WP
    // changeRegistrationStep()
  })

  const backToLogin = document.querySelector('.js-back-login')

  if (backToLogin) {
    backToLogin.addEventListener('click', () => {
      openStep(3)
    })
  }

  const forgetPassword = document.querySelector('.js-forget-password')
  const forgetPasswordForm = document.querySelector('.js-forget-password-form')

  if (forgetPassword) {
    forgetPassword.addEventListener('click', () => {
      openStep('forget-password')
    })
  }

  if (forgetPasswordForm) {
    forgetPasswordForm.addEventListener('submit', () => {
      const forgetPasswordEmail = $(forgetPasswordForm).serializeArray()
      if (validateMail('.js-forget-password-form input[type="email"]')) {
        $.ajax({
          url: window.wp_data.ajax_url,
          type: 'POST',
          data: {
            action: 'forgetPassword',
            data: forgetPasswordEmail,
          },
          beforeSend: function () {
            toggleElement(loader)
            toggleElement(mainModal)
          },
          success: function (response) {
            if (response.data.status === 'success') {
              toggleElement(loader)
              toggleElement(thankYouModal)
            }
          },
          error: function (err) {
            mainModal.classList.remove('opened')
            toggleElement(loader)
            toggleElement(errorModal)
            console.log(err)
          },
        })
      }
    })
  }
}
